import React, { useState, useEffect } from "react";
import ListadoProductos from "./ListadoProductos";
import Mensaje from "../../Mensaje";
import Cargando from "../../Cargando";
import { dbApp } from "../../../firebase/config";
import { eliminarImagen } from "../../Utilerias";

const ProductoPrinciapl = () => {
  const [productos, setProductos] = useState([]);
  const [cargando, setCargando] = useState(false);

  const getProductos = () => {
    setCargando(true);
    const resultadoProductos = [];
    dbApp
      .collection("pizzas")
      .where("ubicacion", "==", "INICIO")
      .get()
      .then((response) => {
        setCargando(false);
        response.forEach((doc) => {
          const producto = doc.data();
          producto.id = doc.id;
          resultadoProductos.push(producto);
        });
        setProductos(resultadoProductos);
      })
      .catch(() => {
        setCargando(false);
      });
  };

  useEffect(() => {
    getProductos();
  }, []);

  const eliminarProducto = (producto) => {
    dbApp
      .collection("pizzas")
      .doc(producto.id)
      .delete()
      .then(() => {
        eliminarImagen(producto.images)
          .then(() => {
            const copiaProductos = [...productos];
            const nuevosProductos = copiaProductos.filter(
              (pr) => pr.id !== producto.id
            );
            setProductos(nuevosProductos);
          })
          .catch(() => {
            const copiaProductos = [...productos];
            const nuevosProductos = copiaProductos.filter(
              (pr) => pr.id !== producto.id
            );
            setProductos(nuevosProductos);
          });
      })
      .catch(() => {
        console.log("Error al borrar producto");
      });
  };

  console.log("----", productos);

  let mostrar;

  if (cargando) {
    mostrar = <Cargando />;
  } else if (productos.length <= 0) {
    mostrar = (
      <div className="mt-5">
        <Mensaje mensaje="No hay productos." />
      </div>
    );
  } else {
    mostrar = (
      <ListadoProductos
        productos={productos}
        eliminarProducto={eliminarProducto}
        getProductos={getProductos}
      />
    );
  }

  return (
    <>
      <div className="d-flex justify-content-between">
        <h3>Productos</h3>
        <a className="btn btn-light" href="/admin/producto/agregar">
          <i className="fa fa-plus" aria-hidden="true"></i> Agregar
        </a>
      </div>

      {mostrar}
    </>
  );
};

export default ProductoPrinciapl;
